import Dispatcher from '../dispatcher';
import ActionTypes from '../constants';
 
class Actions {
    productUpdate(item) {
        Dispatcher.dispatch({
            actionType: ActionTypes.PRODUCT_UPDATE,
            payload: item 
        });
    }
    
}
export default new Actions();